import { gql } from '../types/generated';

export const UPDATE_AUDIENCE = gql(`
  mutation updateAudience($href: String!, $audience: AudienceUpdateInput!) {
    updateAudience(href: $href, audience: $audience) {
      href
      authenticated
      match
      type
      details
      id
    }
  }
`);

export const CREATE_POLICY = gql(`
  mutation createPolicy($policy: PolicyCreateInput!) {
    createPolicy(policy: $policy) {
      ...ViewingPolicyFields
    }
  }
`);

export const UPDATE_POLICY = gql(`
  mutation updatePolicy($href: String!, $policy: PolicyUpdateInput!) {
    updatePolicy(href: $href, policy: $policy) {
      ...ViewingPolicyFields
    }
  }
`);

export const UPSERT_MEDIA_POLICIES = gql(`
  mutation upsertMediaPolicies($media: MediaPolicyInput!) {
    upsertMediaPolicies(media: $media) {
      ...MediaPolicyFields,
      viewingPolicies {
        ...ViewingPolicyFields
      }
    }
  }
`);

export const CREATE_AUDIENCE = gql(`
  mutation createAudience($audience: AudienceCreateInput!) {
    createAudience(audience: $audience) {
      href
      authenticated
      match
      type
      details
    }
  }
`);

export const DELETE_VIEWING_POLICY = gql(`
  mutation deletePolicy($href: String!) {
    deletePolicy(href: $href) {
      href
      success
      reason
    }
  }
`);

export const DELETE_AUDIENCE = gql(`
  mutation deleteAudience($href: String!) {
    deleteAudience(href: $href) {
      href
      success
      reason
    }
  }
`);

export const DELETE_ESNI_RULE = gql(`
  mutation deleteEsniRule($ruleId: String!) {
    deleteEsniRule(ruleId: $ruleId) {
      ruleId
      success
      reason
    }
  }
`);

export const CREATE_ESNI_RULE = gql(`
  mutation createEsniRule($input: EsniRuleInput!) {
    createEsniRule(input: $input) {
      ...EsniRuleFields
    }
  }
`);

export const UPDATE_ESNI_RULE = gql(`
  mutation updateEsniRule($ruleId: String!, $input: EsniRuleInput!) {
    updateEsniRule(ruleId: $ruleId, input: $input) {
      ...EsniRuleFields
    }
  }
`);

export const VALIDATE_ESNI_MEDIA = gql(`
  mutation validateEsniMedia($mediaId: String!) {
    validateEsniMedia(mediaId: $mediaId) {
      ...EsniMediaProcessingResultFields
    }
  }
`);

export const PROCESS_ESNI_MEDIA = gql(`
  mutation processEsniMedia($mediaId: String!) {
    processEsniMedia(mediaId: $mediaId) {
      ...EsniMediaProcessingResultFields
    }
  }
`);
